import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
    const [forms, setForms] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value });
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setLoading(true);
            setError(null);
            
            try {
                await emailjs.send(
                    'service_kpqywmv', // You'll need to replace this with your EmailJS service ID
                    'template_bhfdw9h', // You'll need to replace this with your EmailJS template ID
                    {
                        to_email: 'consulting@edsberger.com',
                        name: forms.name,
                        email: forms.email,
                        message: forms.message,
                    },
                    '1TCzXwqmtfVIl6CZ-' // You'll need to replace this with your EmailJS public key
                );

                setSuccess(true);
                setForms({
                    name: '',
                    email: '',
                    message: ''
                });
            } catch (err) {
                setError('Failed to send message. Please try again later.');
            } finally {
                setLoading(false);
            }
        } else {
            validator.showMessages();
        }
    };

    return (
        <form method="post" className="contact-validation-active" onSubmit={(e) => submitHandler(e)} >
            <div className="row align-items-center">
                <div className="col-md-6 col-md-6 col-12">
                    <div className="form-group">
                        <label>Name*</label>
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            className="form-control"
                            placeholder="Your Name" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col-md-6 col-md-6 col-12">
                    <div className="form-group">
                        <label>Email*</label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            className="form-control"
                            placeholder="Your Email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="fullwidth form-group">
                        <label>Message*</label>
                        <textarea
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            type="text"
                            name="message"
                            className="form-control"
                            placeholder="Message">
                        </textarea>
                        {validator.message('message', forms.message, 'required')}
                    </div>
                </div>
                <div className="col-md-5 order-md-1 order-2 col-12">
                    <div className="submit-area">
                        <button type="submit" className="theme-btn" disabled={loading}>
                            {loading ? 'Sending...' : 'Send'}
                        </button>
                        {loading && (
                            <div id="loader">
                                <i className="ti-reload"></i>
                            </div>
                        )}
                    </div>
                    {success && (
                        <div className="alert alert-success mt-3">
                            Message sent successfully!
                        </div>
                    )}
                    {error && (
                        <div className="alert alert-danger mt-3">
                            {error}
                        </div>
                    )}
                </div>
            </div>
        </form>
    );
}

export default ContactForm;